import firebase from '../../firebase/compat'
import callWithColdStartRetry from './callWithColdStartRetry'
import whenAuthKnown from '../auth/whenAuthKnown'

/**
 * De interviews van één thema, via de super-admin-callable. Zelfde recept als
 * fetchThemes: eerst de inlog afwachten, dan één herkansing bij een koude start.
 *
 * @param {string} themeId
 * @param {{delayMs?: number}} [opties]
 * @returns {Promise<{own: Array<object>, effectWide: Array<object>, unreviewed: Array<object>, gate: object}>}
 */
export const fetchThemeInterviews = async (themeId, opties = {}) => {
    await whenAuthKnown()
    const callable = firebase.app().functions('europe-west1').httpsCallable('getThemeInterviews')
    const result = await callWithColdStartRetry(callable, { themeId }, opties)
    return result.data
}

export default fetchThemeInterviews
